"use client";

import { useLang } from "@/contexts/language-context";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/redy-pos/id6770824537";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kickoff.redy";

/**
 * Badges oficiales de las tiendas para la app nativa "Redy POS"
 * (com.kickoff.redy). Los assets son los badges sin modificar de los
 * generadores oficiales de Apple (EN / ES-MX) y de Google Play (EN / ES-419) —
 * las guías de marca de ambos exigen usarlos tal cual. El PNG de Google trae
 * ~⅓ de padding interno alrededor del arte, por eso se renderiza a 1.5× la
 * altura del SVG de Apple con margen vertical negativo: así ambos SE VEN del
 * mismo tamaño sin agrandar la caja de layout.
 */
export default function AppStoreBadges({
  className = "",
  height = 44,
}: {
  className?: string;
  /** Altura visual (px) del badge de Apple; el de Google compensa su padding. */
  height?: number;
}) {
  const { lang } = useLang();
  const suffix = lang === "es" ? "es" : "en";
  const googleHeight = Math.round(height * 1.5);
  const googleTrim = Math.round(height * 0.25);

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={
          lang === "es"
            ? "Descarga Redy POS en el App Store"
            : "Download Redy POS on the App Store"
        }
        className="shrink-0 transition-opacity hover:opacity-80"
      >
        <img
          src={`/badge-app-store-${suffix}.svg`}
          alt={
            lang === "es"
              ? "Descárgalo en el App Store"
              : "Download on the App Store"
          }
          style={{ height }}
          className="w-auto"
          loading="lazy"
        />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={
          lang === "es"
            ? "Consigue Redy POS en Google Play"
            : "Get Redy POS on Google Play"
        }
        className="shrink-0 transition-opacity hover:opacity-80"
      >
        <img
          src={`/badge-google-play-${suffix}.png`}
          alt={
            lang === "es" ? "Disponible en Google Play" : "Get it on Google Play"
          }
          style={{ height: googleHeight, marginTop: -googleTrim, marginBottom: -googleTrim }}
          className="w-auto"
          loading="lazy"
        />
      </a>
    </div>
  );
}
